// extracted by mini-css-extract-plugin
export var columnItem = "_bm-3";
export var columnItemDraggable = "_bm-4";
export var dragHandle = "_bm-0";
export var dragHandleHovered = "_bm-1";
export var dropdown = "_bm-5";
export var dropdownContent = "_bm-7";
export var dropdownInner = "_bm-6";
export var filterDropdownHeader = "_bm-8";
export var icon = "_bm-2";
export var sectionDivider = "_bm-9";